import { render } from "./CategoryItem.vue?vue&type=template&id=05a75e5a&scoped=true"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"

import "./CategoryItem.vue?vue&type=style&index=0&id=05a75e5a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a75e5a"]])

export default __exports__